import { getDefaultStore } from 'jotai';

import 'jotai-devtools/utils';

/**
 * [Jotai](https://jotai.org)
 *
 * [Store Docs](https://jotai.org/docs/core/store)
 */
export const store = getDefaultStore();
